import { useEffect, useState } from "react";
import { Download, Check, X } from "lucide-react";

export function InstallPWA({ className = "", label = "Installer l'application" }) {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(false);
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    const standalone = window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) setInstalled(true);
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => { setInstalled(true); setDeferred(null); setShowHint(false); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  const isIOS = /iphone|ipad|ipod/i.test(ua) || (/Macintosh/i.test(ua) && typeof document !== "undefined" && "ontouchend" in document);

  const install = async () => {
    if (deferred) {
      deferred.prompt();
      try { await deferred.userChoice; } catch (e) {}
      setDeferred(null);
      return;
    }
    setShowHint(true);
  };

  if (installed) {
    return (
      <span data-testid="pwa-installed" className={`inline-flex items-center gap-2 text-sm text-emerald-400 ${className}`}>
        <Check size={16} /> Application installée
      </span>
    );
  }

  return (
    <div className={`inline-flex flex-col items-center gap-2 ${className}`}>
      <button data-testid="pwa-install-btn" onClick={install}
        className="inline-flex items-center justify-center gap-2 h-11 px-5 rounded-full bg-primary hover:bg-primary/90 text-white font-medium transition-colors w-full sm:w-auto">
        <Download size={16} /> {label}
      </button>
      {showHint && !deferred && (
        <div data-testid="pwa-install-hint" className="relative w-full max-w-xs rounded-2xl bg-black/60 border border-white/10 p-4 text-left text-xs text-muted-foreground">
          <button onClick={() => setShowHint(false)} aria-label="Fermer" className="absolute top-2.5 right-2.5 text-muted-foreground hover:text-foreground"><X size={14} /></button>
          {isIOS ? (
            <p>Sur iPhone/iPad : touchez <span className="text-foreground font-medium">Partager</span> (l'icône ⬆︎) puis <span className="text-foreground font-medium">« Sur l'écran d'accueil »</span> pour installer OMY.</p>
          ) : (
            <p>Dans votre navigateur : ouvrez le menu <span className="text-foreground font-medium">⋮</span> puis <span className="text-foreground font-medium">« Installer l'application »</span> (ou « Ajouter à l'écran d'accueil »).</p>
          )}
        </div>
      )}
    </div>
  );
}
